import { t } from 'i18next'
import React from 'react'
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom'

const UserSideBar = () => {
    const settingsRes = useSelector((state) => state.settingsReducers.settings);
    const location = useLocation();
    const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";

    const links = [
        { to: "/user/allorders", icon: "fa-solid fa-box", label: t("Application Management") },
        { to: "/user/favoriteproducts", icon: "fa-solid fa-heart", label: t("Favorite Products") },
        { to: "/user/addresses", icon: "fa-solid fa-location-dot", label: t("Personal Addresses") },
        { to: "/user/profile", icon: "fa-solid fa-user", label: t("Profile") },
        { to: "/user/wallet", icon: "fa-solid fa-wallet", label: t("Wallet") },
    ];

    return (
        <div className="user-sidebar-card font d-none d-md-block">
            <div className="d-flex flex-column gap-1">
                {links.map((link, i) => {
                    const isActive = location.pathname === link.to;
                    return (
                        <Link to={link.to} key={i} className="text-decoration-none">
                            <div
                                className={`user-sidebar-link ${isActive ? 'active' : ''}`}
                                style={isActive ? { backgroundColor: primaryColor, color: '#fff' } : {}}
                            >
                                <i className={link.icon} style={{ width: '16px', textAlign: 'center', fontSize: '0.85rem' }}></i>
                                <span>{link.label}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    )
}
export default UserSideBar
